import { Layout } from "antd";

import PublicQuoteProvider from "../components/contexts/PublicQuoteContext";
import AskForEmail from "../components/home/AskForEmail";
import EducationalLeader from "../components/home/EducationalLeader";
import Footer from "../components/home/Footer";
import GetAQuote from "../components/home/GetAQuote";
import Page2 from "../components/home/Page2";
import Page3 from "../components/home/Page3";
import WhyDoSelfInsurance from "../components/home/WhyDoSelfInsurance";

export default function Home() {
    return (
        <PublicQuoteProvider>
            <Layout>
                <Layout.Content>
                    <EducationalLeader />
                    <GetAQuote key="banner" />
                    <WhyDoSelfInsurance />

                    <Page2 key="page2" />
                    <AskForEmail />
                    <Page3 key="page3" />
                    <Footer key="footer" />
                </Layout.Content>
            </Layout>
        </PublicQuoteProvider>
    );
}
